;(function($){

    function Departaments() {
        var _ = this;       
        _.API = $("#app_url").val() + "/api/";

        $("#departments_id").on("change", function(e){
            e.preventDefault();

            if($(this).val() != ""){
                _.modules($(this).val());
            }else {
               $("#modules_id").val("").tiggre('change'); 
            }
        });

        if($("#departments_id").val() != ""){
            _.modules($("#departments_id").val());
        }else {
           $("#modules_id").val("").attr('disabled', false).trigger('change'); 
        }
    }

    Departaments.prototype.modules = function(departments_id) {
        var _ = this;

        $.get($("#app_url").val() + "/api/modulos/"+departments_id, function( data ) {
          
            var html = '<option value="">Selecione</option>';

            $.each(data, function(index, value) {
               var selectedStatus = ($("select#modules_id").data('active') == index) ? "selected" : "";
               html += '<option value="'+ index +'" '+ selectedStatus +'>'+ value +'</option>';
            });

            $("select#modules_id").attr('disabled', false).html(html);
        });
    }

   	new Departaments();

}(jQuery));
 
 
 
 
